/**
 * Countdown timer.
 * 
 * @since 1.0.0
 * @author Fahri Rusliyadi <fahri.rusliyadi@gmail.com>
 */

"use strict";

import $ from 'jquery';

// The actual plugin constructor
function Plugin ( $element, options ) {
    this.$element = $element;
    this.options = options;
    this.init();
}

// Avoid Plugin.prototype conflicts
$.extend( Plugin.prototype, {
    init: function() {
        // Set the date we're counting down to
        var countDownDate = new Date(this.options.to);
        countDownDate.setHours(0,0,0,0);
        countDownDate = countDownDate.getTime();

        // Update the count down every 1 second
        var x = setInterval(() => {
            // Get todays date and time
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            // Display the result in the element with id="demo"
            this.$element.html(`
                <span>${hours}</span> :
                <span>${minutes}</span> :
                <span>${seconds}</span>
            `);

            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(x);
                this.$element.html('');
            }
        }, 1000);
    }
} );

export default function() {    
    $('[data-countdown]').each(function() {
        let $this = $(this);

        new Plugin($this, {
            to: $this.data('countdown')
        });
    });
}